import { usePageLevelEvents } from "@/hooks/usePageLevelEvents/usePageLevelEvents";
import { Product, Variant, PageConfig } from "@/types/types";

type Props = {
  product: Product;
  selectedVariant: Variant;
  pageConfig: PageConfig;
};

export const PageLevelEvents = ({
  product,
  selectedVariant,
  pageConfig,
}: Props) => {
  usePageLevelEvents({
    product,
    selectedVariant,
    pageConfig,
  });

  return null;
};
